module.exports = __webpack_public_path__ + "img/close.7464da51.svg";